import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[autoSlash]'
})
export class DateFormatService {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length > 2) value = value.slice(0, 2) + '/' + value.slice(2);
    if (value.length > 5) value = value.slice(0, 5) + '/' + value.slice(5);
    if (value.length > 10) value = value.slice(0, 10); // max mm/dd/yyyy
    input.value = value;
   
  }


   // Format from model to view (NgbDateStruct ➡ string)
    format(date: NgbDateStruct): string {
      if (!date) return '';
      const mm = date.month.toString().padStart(2, '0');
      const dd = date.day.toString().padStart(2, '0');
      return `${mm}/${dd}/${date.year}`;
    }
  
    // Parse from view to model (string ➡ NgbDateStruct)
    parse(value: string): NgbDateStruct | null {
      if (!value) return null;
      const parts = value.trim().split('/');
      if (parts.length !== 3) return null;
      const [mm, dd, yyyy] = parts.map(part => Number(part));
      return { year: yyyy, month: mm, day: dd };
    }
}
